import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export function SET_SELECTED_NODE(state, nodeIds) {
  state.selectedNode = nodeIds;
}
export function SET_META(state, payload) {
  state.wikiMeta = payload;
}

/**
 * @param state
 * @param {Object} payload
 * @param {number} payload.id
 * @param {string} payload.name
 */
export function TOGGLE_HISTORY_CATEGORY_ID(state, payload) {
  state.historyCategory = payload;
}
export function SET_CATEGORY_DELETE_GLOBALLY(state, payload) {
  state.categoryDeleteGlobally = payload;
}
export function SET_CATEGORY_CHILDREN_COUNT(state, payload) {
  state.categoryDeleteGlobally = _objectSpread(_objectSpread({}, state.categoryDeleteGlobally), {}, {
    childrenCount: payload
  });
}
export function SET_DELETED_CATEGORY(state, payload) {
  state.deletedCategory = payload;
}
export function SET_IS_DELETING_PROCESS(state, payload) {
  state.isDeletingGloballyActive = payload;
}